export default __webpack_public_path__ + "static/media/hari-heu.15dced2d.jpg";